const colors = {
	headerBgStart: "rgba(250, 250, 250,1)",
	headerBgEnd: "rgba(220, 220, 220,1)",
	headerBorder: "#AEAEAE",
	dot1: "rgb(255, 95, 88)",
	dot2: "rgb(255, 189, 46)",
	dot3: "rgb(40, 201, 65)",
	titleFont: "rgb(100, 100, 100)",
	bodyBg: "rgb(23, 23, 23)",
	bodyBgWithOpacity: "rgba(23, 23, 23,0.85)",
	bodyBorder: "rgba(60, 60, 60,0.85)",
	bodyFont1: "rgb(40, 254, 14)",
	bodyFont2: "rgb(94, 192, 206)",
	bodyFont3: "rgb(255, 95, 88)",
	bodyFont4: "rgb(245,245,245)",
	bodyFont5: "rgb(240, 216, 0)",
	easterEgg:
		"linear-gradient(90deg, #ff2400, #e81d1d, #e8b71d, #e3e81d, #1de840, #1ddde8, #2b1de8, #dd00f3, #dd00f3)",
	windowShadow: "rgba(0, 0, 0, 0.2)",
	labelColor: "rgb(255, 95, 88)",
	scrollbarThumb: "rgb(85, 85, 85)",
	containerBg: "rgba(240, 240, 255,0.9)",
	btnBg: "rgba(240, 240, 255,1)",
};

export default colors;
